module.exports = __webpack_public_path__ + "img/sec2_button_choice.a2622a4f.jpg";